import React, { useContext, useEffect, useState } from "react";
import { OperativesContext } from "../providers/OperativesProvider";
import { useParams } from "react-router-dom";
import { operativesRef } from "../firebase";
import Footer from "./Footer";
import { doc, updateDoc } from "firebase/firestore";

const OperativesForm = () => {
  const operativesData = useContext(OperativesContext);
  const [operativeData, setOperativeData] = useState({});
  const params = useParams();

  useEffect(() => {
    const operative = operativesData.find((op) => op.uid === params.uid);
    setOperativeData(operative);
  }, [operativesData, params.uid]);

  const inputHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    updateDoc(doc(operativesRef, params.uid), { [name]: value });
  };

  return (
    <div className="settingsFormPage">
      <Footer title={"Operatives"} back={true}>
        {/* <button onClick={addJobDescription} className="adder">
          @
        </button> */}
      </Footer>
      <form className="settingsForm">
        <div className="formLine">
          <label htmlFor="name">Name</label>
          <input
            value={operativeData?.name ?? ""}
            id="name"
            onChange={inputHandler}
            name="name"
            type="text"
          />
        </div>

        <div className="formLine">
          <label htmlFor="initials">Initials</label>
          <input
            value={operativeData?.initials ?? ""}
            id="initials"
            name="initials"
            onChange={inputHandler}
            type="text"
          />
        </div>

        <div className="formLine">
          <label htmlFor="rate">Rate</label>
          <input
            value={operativeData?.rate ?? 0}
            id="rate"
            name="rate"
            onChange={inputHandler}
            type="number"
          />
        </div>
        {/* <label htmlFor="secondaryOperative">
        <input id="secondaryOperative" name="secondaryOperative" type="text" />
      </label> */}

        <div className="formLine">
          <label htmlFor="title">Title</label>
          <input
            value={operativeData?.title ?? ""}
            id="title"
            onChange={inputHandler}
            name="title"
            type="text"
          />
        </div>
      </form>
    </div>
  );
};

export default OperativesForm;
